<template>
  <div id="parenttem">
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Container Component
        <p class="pl-4">|</p>
      </h1>
      <vs-button
        v-if="cmanstatus != 'COMPLETE'"
        size="small"
        color="success"
        type="filled"
        icon="add"
        @click="cusAdd"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis && cmanstatus != 'COMPLETE'"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis && cmanstatus != 'COMPLETE'"
        >Delete</vs-button
      >
      <!-- <p class="pr-4"></p>
      <vs-button
        size="small"
        v-if="btndis3"
        color="#5b3cc4"
        type="filled"
        icon="check_circle_outline"
        @click="ressel"
        >Choose</vs-button
      > -->
    </div>

    <transition-group
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <grid
        v-if="gridshow"
        :key="gridshow"
        @recsel="recsel"
        :cmansDetailsNumber="cmansDetailsNumber"
        class="pt-4"
      ></grid>
    </transition-group>

    <cmancontadd
      v-if="addshow"
      key="addshow"
      :rfcar_code="rfcar_code"
      :acstate="acstate"
      :recid="recid"
      :cmansDetailsNumber="cmansDetailsNumber"
      @grid="grid"
    ></cmancontadd>

    <!-- <b-modal :active.sync="addshow" :width="1024" scroll="keep">
      <cmancontadd
        :acstate="acstate"
        :recid="recid"
        :cmansDetailsNumber="cmansDetailsNumber"
        @grid="grid"
      ></cmancontadd>
    </b-modal> -->
  </div>
</template>

<script>
import grid from "./grid";
import cmancontadd from "./cmancont_add";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  props: ["cmansDetailsNumber", "cmanstatus", "rfcar_code"],
  data() {
    return {
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      finshow: false,
      title: "",
      btn_list: "",
      btn_choose: "",
      btn_add: "",
      btn_edit: "",
      btn_delete: "",
      ask_delete: "",
      del_complete: "",
      del_error: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      btndis2: true,
      btndis3: true,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
    };
  },
  created() {
    // console.log(this.lang_number);
    // console.log(this.resback);
    // console.log(this.cmanstatus);

    this.$store.dispatch("setReportGrid", 0);
    this.gridshow = true;

    this.grid();
    if (typeof this.resback == "undefined") {
      this.searchs = "ALL";
      // this.btndis2 = true;
      // this.btndis3 = false;
    } else {
      // this.btndis2 = false;
      // this.btndis3 = true;
      this.searchs = this.resback;
    }
  },
  watch: {},
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    onSubmit() {
      if (this.$store.state.reportgrid == 0) {
        this.$store.dispatch("setReportGrid", 1);
      } else {
        this.$store.dispatch("setReportGrid", 0);
      }
      // console.log(this.toDate);
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    // ressel() {
    //   // console.log(this.recid);
    //   var vm = this;
    //   vm.$emit("gotres", this.recid);
    // },
    recsel(val) {
      // console.log(val);
      // this.fincharts_code = val;
      // this.finshow = false;
      // setTimeout(() => {
      //   this.finshow = true;
      // }, 300);
      this.btndis = true;
      this.btndis3 = false;

      if (typeof this.resback == "undefined") {
        // this.btndis = true;
        // this.btndis3 = false;
        this.recid = val;
      } else {
        // this.btndis = false;
        // this.btndis3 = true;
        this.recid = val;
      }
    },
    cusAdd() {
      this.recid = 0;
      this.gridshow = false;
      this.addshow = true;
      this.btndis = false;
      this.acstate = "ADD";
      // this.$store.dispatch("setCompanysTypesGrid", 1);
    },
    grid() {
      this.gridshow = true;
      this.addshow = false;
      this.btndis = false;
      if (this.$store.state.reportgrid == 0) {
        this.$store.dispatch("setReportGrid", 1);
      } else {
        this.$store.dispatch("setReportGrid", 0);
      }
    },
    cusEdit() {
      this.addshow = true;
      this.btndis = false;
      this.acstate = "EDIT";
      this.gridshow = false;
      // this.$store.dispatch("setCompanysTypesGrid", 1);
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: this.ask_delete + " " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/cmanconts/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
    mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    grid,
    cmancontadd,
    DatePicker,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
